<h3 mat-dialog-title i18n>
  Delete rule
</h3>
<mat-dialog-content i18n>
  This action will completely remove this rule from every option of this booking item and can not be undone. Do you want to proceed?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()" i18n>No</button>
  <button mat-flat-button color="primary" (click)="onConfirm()" i18n>Yes</button>
</mat-dialog-actions>
